import { render, staticRenderFns } from "./ChangeCasePrefixPopup.vue?vue&type=template&id=0ad10cc4&scoped=true&"
import script from "./ChangeCasePrefixPopup.vue?vue&type=script&lang=js&"
export * from "./ChangeCasePrefixPopup.vue?vue&type=script&lang=js&"
import style0 from "./ChangeCasePrefixPopup.vue?vue&type=style&index=0&id=0ad10cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad10cc4",
  null
  
)

export default component.exports